// pages/Personal Attendance/components/DirectReportPicker.js
//
// Go-live parity (2026-09-24), ATT#6: legacy frmFtoRequest let a supervisor
// file an FTO / COA for one of their active subordinates (frmFtoRequest.vb
// 1273-1306, 1696-1800) — how hourly staff without a login got time off.
// Shown on the NEW FTO / NEW COA forms only, and only when the caller has
// active direct reports (GET /api/fto/direct-reports). The server re-checks
// the scope on submit and records the supervisor stage as approved when the
// filer is the employee's direct supervisor.

import React, { useEffect, useState } from "react";
import { Input, Label } from "reactstrap";
import { getMyDirectReports } from "../ftoService";

const DirectReportPicker = ({ enabled, selfEmpId, value, onChange }) => {
    const [reports, setReports] = useState([]);

    useEffect(() => {
        if (!enabled) { setReports([]); return undefined; }
        let cancelled = false;
        getMyDirectReports()
            .then(({ data }) => { if (!cancelled) setReports(Array.isArray(data) ? data : []); })
            .catch(() => { if (!cancelled) setReports([]); });
        return () => { cancelled = true; };
    }, [enabled]);

    if (!enabled || reports.length === 0) return null;

    const idOf = (r) => String(r?.empId ?? r?.EmpId ?? "");
    const nameOf = (r) => r?.name ?? r?.Name ?? "";

    return (
        <div className="mb-3">
            <Label style={{ fontSize: 12 }}>Filing for</Label>
            <Input
                type="select" bsSize="sm" style={{ maxWidth: 340 }}
                value={value || selfEmpId || ""}
                onChange={(e) => {
                    const id = e.target.value;
                    const match = reports.find((r) => idOf(r) === id);
                    onChange(id, match ? nameOf(match) : undefined);
                }}
            >
                <option value={selfEmpId}>Myself ({selfEmpId})</option>
                {reports.map((r) => (
                    <option key={idOf(r)} value={idOf(r)}>
                        {nameOf(r) || idOf(r)} ({idOf(r)})
                    </option>
                ))}
            </Input>
            <div className="text-muted mt-1" style={{ fontSize: 11 }}>
                Filing for one of your direct reports records your supervisor approval; the request then goes to HR.
            </div>
        </div>
    );
};

export default DirectReportPicker;
